<template lang="pug">
.basketSpecialOffers(v-if="items.length || isLoading")
  template(v-if="isLoading")
    .loader
      ui-loader(:is-responsive="true")
  template(v-else)
    .head Специальные предложения
    .basketSpecialOffersItems
      basket-special-offers-item(
        v-for="item in items"
        :key="item.id"
        :item="item"
      )
</template>

<script>
import { computed } from 'vue'
import BasketSpecialOffersItem from './BasketSpecialOffersItem'
import SpecialOffersController from '../controllers/SpecialOffersController'
export default {
  components: { BasketSpecialOffersItem },
  setup () {
    const controller = SpecialOffersController()
    const items = computed(() => controller.items.value)
    const isLoading = computed(() => controller.isLoading.value)
    controller.requestItems()
    return { items, isLoading }
  }
}
</script>

<style lang="sass">
.basketSpecialOffers
  max-width: $appMaxWidth - 18*$u
  @media (max-width: $appMaxWidth)
    max-width: calc(100vw - #{9*$u})
  @media (max-width: $padWidth)
    max-width: calc(100vw - #{5*$u})
  .loader
    width: 10*$u
    height: 10*$u
    margin: 10*$u auto
  .head
    @include font('h2')
    margin-bottom: 5*$u
  .basketSpecialOffersItems
    display: flex
    gap: 7*$u
    overflow-x: auto
    -ms-overflow-style: none
    scrollbar-width: none
    @media (max-width: $appMaxWidth)
      padding-right: 9*$u
    @media (max-width: $padWidth)
      padding-right: 5*$u
    &::-webkit-scrollbar
      width: 0
      height: 0
</style>
